import { useContactInfo } from '../contactInfo';

export const formRegistry = {
    contactInfo: useContactInfo,
};

export type FormName = keyof typeof formRegistry;
